// extracted by mini-css-extract-plugin
module.exports = {"sectionGroupsWrapper":"NJMAwntg","sectionGroupTitle":"OIlLRIHx","groupWrapper":"jNxBIM1R","citationsSectionWrapper":"mwPg_yVH","citationsTitle":"EtNCtYUQ"};